import React from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type HtmlProps = React.HTMLAttributes<HTMLDivElement>

import { CombinedNumberedHeaderProps } from './NumberedHeader.interface'
import styles from './NumberedHeader.module.scss'
import { getVariantClasses } from './NumberedHeader.style'

const NumberedHeader: React.FC<CombinedNumberedHeaderProps> = ({
  number,
  title,
  subtitle,
  variant = 'gray',
  className,
  twAlignmentClass,
}) => {
  const { variantClasses, numberClasses } = getVariantClasses(variant, styles)

  const baseTitleClasses =
    'font-dm-mono tracking-widest w-fit text-[24px] md:text-[32px] mb-[30px] text-center font-normal inline-block !tracking-[-0.05em]'
  const baseSubtitleClasses =
    'font-gt-haptik tracking-widest w-fit text-[20px] mt-[18px] text-center font-normal inline-block !tracking-[0.4px] text-white-400'

  return (
    <>
      <h2 className={`${baseTitleClasses} ${className} ${twAlignmentClass}`}>
        <span className={`py-[3px] px-2 ${variantClasses} ${numberClasses}`} aria-disabled>
          {number}
        </span>
        <span className={`py-[3px] px-2 ${variantClasses}`}>{title}</span>
      </h2>
      {subtitle && <p className={`${baseSubtitleClasses} ${twAlignmentClass}`}>{subtitle}</p>}
    </>
  )
}

export default NumberedHeader
